/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateAssetOptions,
  CreateAssetStatus201,
  CreateAssetStatus400,
  CreateAssetStatus500,
} from '../types/CreateAsset'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createAsset } from '../clients/createAsset'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createAssetMutationKey = () => [{ url: '/v1/assets' }] as const

export function createAssetMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createAssetMutationKey()
  return mutationOptions<
    CreateAssetStatus201,
    ResponseErrorConfig<CreateAssetStatus400 | CreateAssetStatus500>,
    CreateAssetOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createAsset({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Create an asset
 * {@link /v1/assets}
 */
export function useCreateAsset<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateAssetStatus201,
      ResponseErrorConfig<CreateAssetStatus400 | CreateAssetStatus500>,
      CreateAssetOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createAssetMutationKey()

  const baseOptions = createAssetMutationOptions(config) as UseMutationOptions<
    CreateAssetStatus201,
    ResponseErrorConfig<CreateAssetStatus400 | CreateAssetStatus500>,
    CreateAssetOptions,
    TContext
  >

  return useMutation<
    CreateAssetStatus201,
    ResponseErrorConfig<CreateAssetStatus400 | CreateAssetStatus500>,
    CreateAssetOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateAssetStatus201,
    ResponseErrorConfig<CreateAssetStatus400 | CreateAssetStatus500>,
    CreateAssetOptions,
    TContext
  >
}
